import React from "react";

function Masthead() {
   return (
      <section className="w-full bg-light-4 py-12 md:py-16 lg:py-24 px-6">
         <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 flex justify-center">
               <img
                  src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d"
                  alt="Équipe souriante"
                  className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-md"
               />
            </div>
            <div className="flex-1 text-center md:text-left">
               <h2 className="text-title font-sans font-bold text-dark-1 mb-4">
                  👉 Une question, une idée, un projet ? <br className="hidden sm:block" /> Parlons-en !
               </h2>
               <p className="text-normal font-sans text-light-1 leading-relaxed">
                  Chez <span className="text-blue-1 font-semibold">GoNextMaker</span>,
                  on aime garder le contact avec notre communauté d’apprenants, de parents, de tuteurs et de partenaires.
               </p>
               <p className="text-normal font-sans text-dark-3 mt-3">
                  Choisis le bon canal, et on te répond vite 🚀
               </p>
            </div>
         </div>
      </section>
   )
};

export default Masthead;
